// RFC 6901 JSON Pointer helpers.

export function parsePointer(pointer: string): string[] {
  if (pointer === '' || pointer === '/') return pointer === '/' ? [''] : [];
  if (!pointer.startsWith('/')) return [];
  return pointer
    .slice(1)
    .split('/')
    .map((segment) => segment.replace(/~1/g, '/').replace(/~0/g, '~'));
}

export function formatPointer(segments: readonly (string | number)[]): string {
  return segments.map((s) => '/' + String(s).replace(/~/g, '~0').replace(/\//g, '~1')).join('');
}

/** True when `pointer` equals `prefix` or lies below it. */
export function isUnder(pointer: string, prefix: string): boolean {
  return pointer === prefix || pointer.startsWith(prefix + '/');
}
